export const colors = {
  primary: "#EA3323",
};
